import React from "react"
import { Link } from "gatsby"
import "../sass/mystyles.scss"

import Image from "gatsby-image"

const ProjectPreview = ({ id, slug, title, imageData }) => (
  <div className="slider-item is-paddingless">
    <div className="card">
      <div className="card-image">
        <Link to={`/${slug}/`} onClick={id}>
          <figure className="image">
            <Image fluid={imageData} alt={title} key={`content_title_${id}`} />
          </figure>
          <div className="card-content is-overlay left">
            <h2 className="title is-size-3-desktop is-size-4-tablet is-size-6-mobile has-text-weight-normal has-text-white text-shadow">
              {title}
            </h2>
          </div>
        </Link>
      </div>
    </div>
  </div>
)

export default ProjectPreview
